import PlKaptcha from "./components/Kaptcha";
import PlTask from './components/Task';
export default {
  PlKaptcha,
  PlTask,
  version: "1.0.0"
};



// WEBPACK FOOTER //
// ./src/index.js